export function syncActionFormCurrentState(formElement) {
  if (!(formElement instanceof Element)) {
    return false
  }

  const formInputs = formElement.querySelectorAll('.js-form-input')
  if (formInputs.length === 0) {
    return false
  }

  formInputs.forEach((input) => {
    input.classList.remove('current')
  })

  for (const input of formInputs) {
    if ((input.value ?? '') !== '') {
      continue
    }

    input.classList.add('current')
    return true
  }

  return true
}
